import api from './api';

// ─── Tipos ────────────────────────────────────────────────────────────────────

export interface FaturamentoRequest {
  clientId: string;
  dataInicio?: string;
  dataFim?: string;
}

export interface FaturamentoResult {
  faturaId: string;
  numeroFatura: number;
  quantidadeApontamentos: number;
  valorTotal: number;
  apontamentosIds: string[];
}

export interface PreviewFaturamento {
  quantidadeApontamentos: number;
  valorTotal: number;
  apontamentos: Array<{
    id: string;
    data: string;
    horaInicio: string;
    horaFim: string;
    minutosTotais: number;
    tipoHora: string;
    valorHora: string;
    valorCalculado: number;
    ticket: {
      codigo: string;
      titulo: string;
    };
    user: {
      name: string;
    };
  }>;
  totaisPorTipo: Array<{
    tipoHora: string;
    quantidade: number;
    valorTotal: number;
  }>;
}

// ─── Service Functions ────────────────────────────────────────────────────────

/**
 * Gera faturamento em lote para um cliente
 */
export const gerarFaturamento = async (data: FaturamentoRequest): Promise<FaturamentoResult> => {
  const response = await api.post('/faturamento/gerar', data);
  return response.data;
};

/**
 * Busca preview de faturamento (apontamentos não faturados)
 */
export const getPreviewFaturamento = async (
  clientId: string,
  dataInicio?: string,
  dataFim?: string
): Promise<PreviewFaturamento> => {
  const params = new URLSearchParams();
  params.append('clientId', clientId);
  if (dataInicio) params.append('dataInicio', dataInicio);
  if (dataFim) params.append('dataFim', dataFim);

  const response = await api.get(`/faturamento/preview?${params.toString()}`);
  return response.data;
};

/**
 * Gera faturamento para tickets específicos
 */
export const faturarTickets = async (ticketIds: string[]): Promise<FaturamentoResult> => {
  const response = await api.post('/faturamento/tickets', { ticketIds });
  return response.data;
};
